import React from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {OrderSummaryDataHook} from '../../OrderSummary';
import {useControllerProps} from '../../../../../../../domain/controllers/ControllerContext';
import s from './DestinationPicker.scss';

type DestinationPickerProps = {
  dataHook: string;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export const DestinationPicker = ({dataHook}: DestinationPickerProps) => {
  const {t} = useTranslation();
  const {hasShippingDestination, handleChangeRegion, shouldShowShipping, shouldShowTax, shouldHideCountryPicker} =
    useControllerProps().orderStore;

  const {cartModel} = useControllerProps().cartStore;

  const getChooseRegionTranslationKey = (): string => {
    if (shouldShowShipping && shouldShowTax) {
      return 'cart.shipping_destination.shipping_and_tax.choose_region';
    }
    if (shouldShowShipping && !shouldShowTax) {
      return 'cart.shipping_destination.choose_region';
    }
    return 'cart.shipping_destination.tax.choose_region';
  };

  const getRegion = (): string => {
    const {deliveryInfo} = cartModel;

    let shippingLocation = t('cart.fallback_estimated_shipping_address');

    if (deliveryInfo.address.countryFullname) {
      shippingLocation = deliveryInfo.address.countryFullname;

      if (deliveryInfo.address.subdivisionFullname) {
        shippingLocation = t('cart.estimated_shipping_address', {
          country: deliveryInfo.address.countryFullname,
          subdivision: deliveryInfo.address.subdivisionFullname,
        });
      }
    }

    return shippingLocation;
  };

  return shouldHideCountryPicker ? null : (
    <div className={s.location} data-hook={dataHook}>
      <button
        data-hook={OrderSummaryDataHook.DestinationPickerChangeRegion}
        type="button"
        onClick={() => handleChangeRegion()}
        aria-haspopup={true}
        aria-describedby="change-region-description"
        aria-label={
          hasShippingDestination
            ? t('cart.sr_change_destination', {destinationName: getRegion()})
            : t(getChooseRegionTranslationKey())
        }>
        {hasShippingDestination ? getRegion() : t(getChooseRegionTranslationKey())}
      </button>
    </div>
  );
};
